
import { Button } from "@/components/ui/button";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useEffect } from "react";
import { Home, ArrowLeft } from "lucide-react";

export default function NotFound() {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  
  useEffect(() => {
    // Log information about the 404 page for debugging
    console.log("404 page loaded, authenticated:", isAuthenticated);
    
    // Automatically redirect after a short delay if user is authenticated
    if (isAuthenticated) {
      const timer = setTimeout(() => {
        navigate("/projects-selector");
      }, 5000);
      
      return () => clearTimeout(timer);
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background">
      <div className="container flex flex-col items-center justify-center gap-6 px-4 py-16">
        <div className="bg-blue-100 rounded-full p-4">
          <Home className="h-12 w-12 text-blue-600" />
        </div>
        <h1 className="text-5xl font-bold tracking-tighter sm:text-6xl">404</h1>
        <p className="max-w-[500px] text-gray-500 md:text-xl/relaxed lg:text-base/relaxed xl:text-xl/relaxed text-center">
          The page you're looking for doesn't exist or has been moved.
          {isAuthenticated && (
            <span className="block mt-2">
              You'll be redirected to the project selector page automatically...
            </span>
          )}
        </p>
        <div className="flex flex-col sm:flex-row gap-4">
          <Button asChild>
            <Link to={isAuthenticated ? "/projects-selector" : "/login"}>
              {isAuthenticated ? "Go to Projects" : "Go to Login"}
            </Link>
          </Button>
          <Button variant="outline" onClick={() => navigate(-1)}>
            <ArrowLeft className="mr-2 h-4 w-4" /> Go Back
          </Button>
        </div>
      </div>
    </div>
  );
}
